import { getAssetURL } from 'src/helpers';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import {
  SUBSCRIBED_STATUS,
  TRIAL_STATUS,
  TRIAL_SUBSCRIBED_STATUS,
  EXPIRED_STATUS,
  PACKAGE_NAME01,
  PACKAGE_NAME02,
  PACKAGE_NAME03,
  ENTERPRISE
} from './common';

export const PLAN_STATUS_DISPLAY_CONFIG = {
  trial: {
    name: TRIAL_STATUS,
    badgeStatus: 'warning',
    label: 'AdminHTML.SubscriptionV5.PlanStatus.trial_Name',
    description: 'AdminHTML.SubscriptionV5.PlanStatus.trial_Content',
    background: getAssetURL(ADMIN_APP_ASSET_PATHS.subscriptionV5.trialStatusBg)
  },
  trial_subscribed: {
    name: TRIAL_SUBSCRIBED_STATUS,
    badgeStatus: 'success',
    label: 'AdminHTML.SubscriptionV5.PlanStatus.trial_subscribed_Name',
    description: 'AdminHTML.SubscriptionV5.PlanStatus.trial_subscribed_Content',
    background: getAssetURL(ADMIN_APP_ASSET_PATHS.subscriptionV5.subscribedStatusBg)
  },
  subscribed: {
    name: SUBSCRIBED_STATUS,
    badgeStatus: 'success',
    label: 'AdminHTML.SubscriptionV5.PlanStatus.subscribed_Name',
    description: 'AdminHTML.SubscriptionV5.PlanStatus.subscribed_Content',
    background: getAssetURL(ADMIN_APP_ASSET_PATHS.subscriptionV5.subscribedStatusBg)
  },
  expired: {
    name: EXPIRED_STATUS,
    badgeStatus: 'critical',
    label: 'AdminHTML.SubscriptionV5.PlanStatus.expired_Name',
    description: 'AdminHTML.SubscriptionV5.PlanStatus.expired_Content',
    background: getAssetURL(ADMIN_APP_ASSET_PATHS.subscriptionV5.expiredStatusBg)
  }
};

export const PACKAGE_INFORMATION = {
  [PACKAGE_NAME01]: {
    name: 'AdminHTML.SubscriptionV5.ExplorePackages.launch',
    features: [
      'advancedProductFilters',
      'smartSearch',
      'aiPoweredSearch',
      'aiPoweredRecommendation',
      'predictiveProductBundles',
      'postPurchaseFeature',
      'metafields',
      'preOrder',
      'commerceSearchMerchandising',
      'standardSync',
      'themesAppsIntegrated',
      'analytics90Days',
      'shopifyMarketFeatures'
    ],
    featureLabel: 'AdminHTML.SubscriptionV5.ExplorePackages.launch_CoreFeatures_Title'
  },
  [PACKAGE_NAME02]: {
    name: 'AdminHTML.SubscriptionV5.ExplorePackages.convert',
    features: [
      'inCollectionSearch',
      'collectionMerchandising',
      'promotionalBanners',
      'b2bWholesaleFeatures',
      'embeddedBundles',
      'analytics180Days',
      'advancedSync'
    ],
    featureLabel: 'AdminHTML.SubscriptionV5.ExplorePackages.convert_CoreFeatures_Title'
  },
  [PACKAGE_NAME03]: {
    name: 'AdminHTML.SubscriptionV5.ExplorePackages.accelerate',
    features: [
      'aiPersonalizedSearch',
      'aiPersonalizedRecommendation',
      'aiPersonalizedProductBundles',
      'collectionMerchandising',
      'variantDisplay',
      'analytics365Days',
      'customerSuccessManager',
      'premiumSupportPackage',
      'customization',
      'unlimitedBackInStock'
    ],
    featureLabel: 'AdminHTML.SubscriptionV5.ExplorePackages.accelerate_CoreFeatures_Title'
  },
  [ENTERPRISE]: {
    name: 'AdminHTML.SubscriptionV5.ExplorePackages.enterprise_Name',
    features: [
      'customGmvTiers',
      'unlimitedAllFeatures',
      'priorSupport',
      'customizationRequests',
      'premiumWithDedicated',
      'dedicatedInfrastructure',
      'shopifyB2bIntegration'
    ],
    featureLabel: 'AdminHTML.SubscriptionV5.ExplorePackages.enterprise_ExclusivePerks_Title'
  }
};

export const SUBSCRIPTION_V5_DOWNGRADE_COMPARE = {
  PACKAGE_LEVEL02_TO_LEVEL01: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.convert',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchFeature',
          items: [[true, 'AdminHTML.SubscriptionV5.FeaturesCommon.inCollectionSearch', true]]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.productFiltersFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertMetafield']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertMerchandisingRules'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandising_CampaignSchedule'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.collectionMerchandising'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.promotionalBanners'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.bis_Notifications']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.recommendationFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.embeddedBundles']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.analyticsFeature',
          items: [[true, 'AdminHTML.SubscriptionV5.FeaturesCommon.analytics180Days']]
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.launch',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchFeature',
          items: [[false, 'AdminHTML.SubscriptionV5.FeaturesCommon.inCollectionSearch', true]]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.productFiltersFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchMetafield']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchMerchandisingRules'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandising_CampaignSchedule'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.collectionMerchandising'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.promotionalBanners'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.bis_Notifications']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.recommendationFeature',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.embeddedBundles']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.analyticsFeature',
          items: [[true, 'AdminHTML.SubscriptionV5.FeaturesCommon.analytics90Days']]
        }
      ]
    }
  },
  PACKAGE_LEVEL03_TO_LEVEL02: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.accelerate',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.personalizedFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedSearch01', true],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01', true],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedProductBundles01', true]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchAndFiltersFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateMetafield'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateRangeSlider']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateMerchandisingRules'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.acceleratePreOrderCampaignLimit'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateBackInStockLimit'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.abTesting']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.supportPackage',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.customerSuccessManager'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.premiumSupportPackage'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.customerSuccessManager']
          ]
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.convert',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.personalizedFeature',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedSearch01', true],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01', true],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedProductBundles01', true]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchAndFiltersFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertMetafield'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertNonCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertRangeSlider']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertMerchandisingRules'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertPreOrderCampaignLimit'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertBackInStockLimit'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.abTesting']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.supportPackage',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.customerSuccessManager'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.premiumSupportPackage'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.customerSuccessManager']
          ]
        }
      ]
    }
  },
  PACKAGE_LEVEL03_TO_LEVEL01: {
    LEFT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.accelerate',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.personalizedFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedSearch01', true],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01', true],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedProductBundles01', true]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchAndFiltersFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.inCollectionSearch'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateMetafield'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateRangeSlider'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.convertCustomFilterTree']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.accelerateMerchandisingRules'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandising_CampaignSchedule'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.collectionMerchandising'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.promotionalBanners'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.bis_Notifications']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.analyticsFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.analytics365Days'],
            [-1, 'AdminHTML.SubscriptionV5.FeaturesCommon.more']
          ]
        }
      ]
    },
    RIGHT: {
      plan: 'AdminHTML.SubscriptionV5.ExplorePackages.launch',
      features: [
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.personalizedFeature',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedSearch01', true],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedRecommendation01', true],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.aiPersonalizedProductBundles01', true]
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.searchAndFiltersFeature',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.inCollectionSearch'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchMetafield'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchNonCustomFilterTree'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchRangeSlider'],
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchCustomFilterTree']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandisingFeature',
          items: [
            [true, 'AdminHTML.SubscriptionV5.FeaturesCommon.launchMerchandisingRules'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.merchandising_CampaignSchedule'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.collectionMerchandising'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.promotionalBanners'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.bis_Notifications']
          ]
        },
        {
          name: 'AdminHTML.SubscriptionV5.FeaturesCommon.b2bWholesaleFeatures',
          items: [
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.b2bWholesaleProductSync'],
            [false, 'AdminHTML.SubscriptionV5.FeaturesCommon.b2bBulkLayoutVisualEditor']
          ]
        }
      ]
    }
  }
};

export const SUBSCRIBE_CONTENT_MODAL = {
  PRICE_CHANGE: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.trialCaseSubscribe_Title',
    description: [
      'AdminHTML.SubscriptionV5.SubscribeModal.trialPriceChange_Description01',
      'AdminHTML.SubscriptionV5.SubscribeModal.trialPriceChange_Description02'
    ],
    showBaseGMV: true
  },
  TRIAL_NO_PRICE_CHANGE: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.trialCaseSubscribe_Title',
    description: [
      'AdminHTML.SubscriptionV5.SubscribeModal.trialNoPriceChange_Description01',
      'AdminHTML.SubscriptionV5.SubscribeModal.trialNoPriceChange_Description02'
    ],
    showBaseGMV: true
  },
  TRIAL_ENDED: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.trialCaseSubscribe_Title',
    description: ['AdminHTML.SubscriptionV5.SubscribeModal.subscribePackage_Description'],
    showBaseGMV: true
  },
  PRICE_NO_CHANGE: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.trialCaseSubscribe_Title',
    description: ['AdminHTML.SubscriptionV5.SubscribeModal.subscribePackage_Description'],
    showBaseGMV: false
  },
  UPGRADE_PLAN: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.upgradeSubscribe_Title',
    description: ['AdminHTML.SubscriptionV5.SubscribeModal.subscribePackage_Description'],
    showBaseGMV: false
  },
  DOWNGRADE_PLAN: {
    title: 'AdminHTML.SubscriptionV5.SubscribeModal.downgradeSubscribe_Title',
    description: ['AdminHTML.SubscriptionV5.SubscribeModal.downgradeSubscribe_Description'],
    showBaseGMV: false
  }
};
